import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { VOUCHER_STATUS } from '@app/constant/VoucherConstant'
import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import { InertiaLink } from '@inertiajs/inertia-react'
import PageviewIcon from '@mui/icons-material/Pageview'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'

export default function VoucherIndex({ vouchers }) {
  const { t } = useTranslation()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'name',
              Header: t('VOUCHERS.NAME'),
              accessor: 'name',
              type: 'string',
            },
            {
              id: 'codes_count',
              Header: t('VOUCHERS.TOTAL_CODES'),
              accessor: 'codes_count',
              type: 'number',
              autoHide: true,
            },
            {
              id: 'total_codes_get_price',
              Header: t('VOUCHERS.TOTAL_COST'),
              accessor: 'total_codes_get_price',
              type: 'number',
            },
            {
              id: 'campaigns_count',
              Header: t('VOUCHERS.CAMPAIGNS'),
              accessor: 'campaigns_count',
              type: 'number',
            },
            {
              id: 'expired_date',
              Header: t('VOUCHERS.EXPIRED'),
              accessor: 'expired_date',
              type: 'dateTime',
              disableFilters: true,
            },
            {
              id: 'type',
              Header: t('VOUCHER.VOUCHER_TYPE'),
              accessor: ({ type }) => t(`CODES.${type.toUpperCase()}`),
              type: 'singleSelect',
              typeCategories: 'Type',
              options: [
                { value: VOUCHER_TYPE.STANDARD, name: t('VOUCHERS.STANDARD') },
                { value: VOUCHER_TYPE.PREMIUM, name: t('VOUCHERS.PREMIUM') },
              ],
            },
            {
              id: 'status',
              Header: t('VOUCHERS.STATUS'),
              accessor: ({ status }) => t(`TABLE.${status.toUpperCase()}`),
              type: 'singleSelect',
              options: [
                { value: VOUCHER_STATUS.ACTIVE, name: t('VOUCHERS.ACTIVE') },
                { value: VOUCHER_STATUS.IN_ACTIVE, name: t('VOUCHERS.INACTIVE') },
              ],
              autoHide: true,
            },
            {
              id: 'actions',
              Header: t('VOUCHERS.ACTIONS'),
              disableFilters: true,
              cell: {
                style: { whiteSpace: 'nowrap' },
              },
              align: 'center',
              type: 'string',
              Cell: ({ row }) => (
                <IconButton component={InertiaLink} href={route('merchant.vouchers.show', row.original.id)}>
                  <PageviewIcon />
                </IconButton>
              ),
            },
          ]}
          data={vouchers}
          routeName="merchant.vouchers.index"
        />
      </Grid>
    </Grid>
  )
}
